import React, { useState } from 'react';
import { ISchemaType } from '../../models/Schema.model';
import { process, State } from '@progress/kendo-data-query';
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import CommandCell from '../userAdmin/CommandCell';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { locale } from '../../common/localization/localizationService';

export interface ISurveyTypesGridProps {
  data: Array<ISchemaType>;
  className?: string;
  editSurveyType: (dataItem: ISchemaType) => void;
  deleteSurveyType: (dataItem: ISchemaType) => void;
}

export default function SurveyTypesGrid(
  props: ISurveyTypesGridProps
): JSX.Element {
  const [dataState, setDataState] = useState<State>({
    sort: [
      {
        dir: 'asc',
        field: 'name',
      },
    ],
    take: 26,
    skip: 0,
  });
  const { editSurveyType, deleteSurveyType } = props;

  const dataStateChange = (event: Record<string, any>): void => {
    setDataState(event.data);
  };

  const EditCell = (props: any): JSX.Element => {
    return <CommandCell {...props} edit={editSurveyType} icon={faEdit} />;
  };

  const DeleteCell = (props: any): JSX.Element => {
    return <CommandCell {...props} edit={deleteSurveyType} icon={faTrash} />;
  };

  const result = process(props.data, dataState);

  return (
    <>
      <Grid
        {...dataState}
        className={props.className + ' survey-types-grid'}
        data={result}
        selectedField="selected"
        pageable
        resizable
        pageSize={26}
        onDataStateChange={dataStateChange.bind(this)}
      >
        <GridNoRecords>{'There are not any schema types'}</GridNoRecords>

        <GridColumn field="name" title={locale.surveyTypesPage._name} />
        <GridColumn field="key" title={locale.surveyTypesPage._key} />
        <GridColumn cell={EditCell.bind(this)} width={26} sortable={false} />
        <GridColumn cell={DeleteCell.bind(this)} width={26} sortable={false} />
      </Grid>
    </>
  );
}
